import { AppConfigurationClient } from '@azure/app-configuration';
import { AZURE_APP_CONFIG_CONNECTION_STRING } from './constants';

const connectionString: string = AZURE_APP_CONFIG_CONNECTION_STRING;
const configClient = new AppConfigurationClient(connectionString);
const uri = window.location.href;
let environment = 'prod';
if (uri?.match('-uat')) environment = 'uat';
if (uri?.match('-test')) environment = 'test';
if (uri?.match('localhost')) environment = 'test';

const getFeatureFlag = async () => {
  let maintenanceEnabled = false;
  let disasterEnabled = false;
  let otpEnabled = false;

  try {
    const flags: Record<string, boolean> = {};
    const settings = configClient.listConfigurationSettings({
      keyFilter: '.appconfig.featureflag/*',
      labelFilter: environment,
    });
    for await (const setting of settings) {
      if (setting.value) {
        const flagName = setting.key.replace('.appconfig.featureflag/', '');
        flags[flagName] = JSON.parse(setting.value).enabled;
      }
    }

    maintenanceEnabled = flags['maintenancePage'] ?? false;
    disasterEnabled = flags['disasterPage'] ?? false;
    otpEnabled = flags['otpVerification'] ?? false;
  } catch (error) {
    console.log('[AppConfig] Failed to fetch feature flags:', error);
  }

  if (maintenanceEnabled) return { flag: 'maintenance', maintenanceEnabled: true, otpEnabled };
  if (disasterEnabled) return { flag: 'disaster', maintenanceEnabled: true, otpEnabled };
  return { flag: 'main', maintenanceEnabled: false, otpEnabled };
};

export default getFeatureFlag;
